<script lang="ts">
  // UI components
  import * as Accordion from '$lib/components/ui/accordion/index.js';
  import { Input } from '$lib/components/ui/input/index.js';
  import { Label } from '$lib/components/ui/label/index.js';

  import { hrControls } from '$lib/PersistedState.svelte';
</script>

<Accordion.Item value="heating-rate-controls">
  <Accordion.Trigger>Heating rate controls</Accordion.Trigger>
  <Accordion.Content>
    <div class="flex flex-row gap-x-5 px-2">
      <div class="w-1/2 text-left">
        <Label for="avg-window-length">Average window length</Label>
        <Input
          id="avg-window-length"
          type="number"
          class="mt-2"
          min="1"
          max="30"
          bind:value={hrControls.avgWindowLength}
        />
        <div class="pt-2 pl-5 text-xs">
          Controls how many temperature readings are averaged together. Lower values (2-3) provide
          quick, precise readings but may show more noise. Mid values (4-10) smooth out fluctuations
          but slightly delay and reduce precision of readings. Very high values smooth the curve
          drastically with a trade-off in precision. Set to 1 to disable averaging (default: 5).
        </div>
      </div>
      <div class="w-1/2 text-left">
        <Label for="delta-span">Delta span</Label>
        <Input
          id="delta-span"
          type="number"
          class="mt-2"
          min="2"
          max="30"
          bind:value={hrControls.deltaSpan}
        />
        <div class="pt-2 pl-5 text-xs">
          Sets the time interval used to calculate heating rate. Smaller values (2-5) give
          near-real-time rates but may show more fluctuation. Larger values (6-30) provide smoother
          trends but increase the delay between actual and displayed rates (default: 15).
        </div>
      </div>
    </div>
  </Accordion.Content>
</Accordion.Item>
